<template>
  <div class='table-box'>
    <global-tag>

    </global-tag>
    <div class='table_title'>
      <div class='btn_group'>
        <el-button type='primary' class='button downOutBtns' @click='createExcel(1)'>基本数据下载模版
        </el-button>
        <div style='display: none'>
          <input @change='fileChange(1)' id='speechUpload' type='file' />
        </div>
        <label for='speechUpload' class='labelImportBtn inDwonBtns'>
          <span>基本数据导入</span>
        </label>
      </div>
      <div class='btn_group'>
        <el-button type='primary' class='button downOutBtns' @click='createExcel(2)'>本周菜单下载模版
        </el-button>
        <div style='display: none'>
          <input @change='fileChange(1)' id='speechUpload' type='file' />
        </div>
        <label for='speechUpload' class='labelImportBtn inDwonBtns'>
          <span>本周菜单导入</span>
        </label>
      </div>
      <div class='btn_group'>
        <el-button type='primary' class='button downOutBtns' @click='createExcel(3)'>本周课程下载模版
        </el-button>
        <div style='display: none'>
          <input @change='fileChange(1)' id='speechUpload' type='file' />
        </div>
        <label for='speechUpload' class='labelImportBtn inDwonBtns'>
          <span>本周课程导入</span>
        </label>
      </div>
      <div class='btn_group'>
        <el-button type='primary' class='button downOutBtns' @click='createExcel(4)'>人员风采下载模版
        </el-button>
        <div style='display: none'>
          <input @change='fileChange(1)' id='speechUpload' type='file' />
        </div>
        <label for='speechUpload' class='labelImportBtn inDwonBtns'>
          <span>人员风采导入</span>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['reload'], //注入
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
    createExcel(value) {
      let url = ''
      let titlte = ''
      if (value == 1) {
        url = '/jjyl/admin/tyzx/bigScreen/info/downLoadTemplate'
        titlte = "基本数据.xls"
      } else if(value==2) {
        url = '/jjyl/admin/buWeekFood/info/downLoadTemplate'
        titlte = "本周菜单数据.xls"
      }else if(value==3) {
        url = '/jjyl/admin/buWeekCourse/info/downLoadTemplate'
        titlte = "本周课程数据.xls"
      }else if(value==4) {
        url = '/jjyl/admin/buTeacherStudentCharacteristic/info/downLoadTemplate'
        titlte = "人员风采.xls"
      }
      this.request2({
        url: url,
        data: {
          pageNo: 1,
          pageSize: 100,
        },
        method: "POST",
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = titlte
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("下载成功")
        }
      })
    },

    // 导入
    async fileChange(event) {
      console.log(event)
      const file = event.target.files[0]
      console.log(file)
      const personType = '1'
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      let formData = new FormData()
      formData.append('personType', personType)
      console.log(formData)
      formData.append('file', file)
      let result = await this.$http.post(
        'jjyl/admin/homePage/bigScreen/info/importData',
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById('speechUpload')
      fileEle.value = ''
      if (result.code == 200) {
        this.$message.success(result.message)
      } else {
        this.$message.warning(result.message)
      }
    },

  }
}
</script>
<style lang='less' scoped>
/deep/ .table_title {
  margin-top: 20px !important;
  justify-content: flex-start !important;
}

.searchBox {
  display: flex;

  .content {
    flex: 1;
  }
}

/deep/ .btn_group {
  margin-top: 0px !important;
}

.button {
  margin-bottom: 4px;
}

.operBtn {
  cursor: pointer;
  margin-left: 10px;
}
</style>